<template>
  <div class="content-wrapper" >
    <div class="mt-5 mb-4"></div>
      <div class="overlay-wrapper" v-if="load">
            <div class="overlay" style="flex-direction: column">
              <i class="fas fa-3x fa-sync-alt fa-spin"></i>
              <div class="text-bold pt-2">Cargando...</div>
            </div>
          </div>
    <div class="content">
      <div class="container-fluid" style="padding: 0px">
        <div class="col-md-12" style="margin-bottom: 10px">
       <div class="col-12" style="display: flex;justify-content: flex-end;">
                <button  @click="Descargar" class="seeCondition" style="background: #007bff;">Descargar Puntos</button>
            </div>
        <div>
          <div class="row" style="margin-bottom: 13px">
            <div v-if="change > 0" class="col-12" style="margin-top: 27px;">
                
                <button class="seeCampaña" :class="{'changeColor': !seleccion}" @click="campanaTwo" style="background: rgb(90 45 130 / 37%);">{{vcampanaOne}}</button>
                <button v-if="One == '1'" class="seeCampaña" :class="{'changeColor': seleccion}" @click="campanaOne" style="background: rgba(90, 45, 130, 0.37);">{{vcampanaTwo}}</button>
               

            </div>
          </div>
           <div v-show="this.seleccion">
             <div class="col-12" style="margin-top: 27px;">
              <div class="TotalPoint"><i class="fas fa-star" style="color: #ebf803e0;margin-right: 7px;"></i> 
              <span style="font-weight: 400;padding-right: 6px;color: #337ab7;">Total de Puntos:  </span>
               <span style="font-weight: bold;color: rgb(90, 45, 130);font-size: 17px;">{{totalPuntosTwo}} </span>  </div>
               <div v-if="change > 0" class="TotalPoint" style="color: rgb(201 201 201);font-size: 14px;padding-bottom: 15px;"> Fecha de Actualización: {{fechaTwo.substring(0,10)}}</div>
            </div>
          <div class="row" style="margin-bottom: 74px;margin-right: 0.5px;margin-left: 0.5px;">
             
             <div
            class="col-md-12"
           
            style="margin-bottom: 0px; padding-right: 0; padding-left: 0"
          >
            <div
              class="card card-success collapsed-card"
              style="margin-bottom: 10px;"
            >
              <div>
                <div>
                  <div></div>
                </div>
              </div>
              <div 
              v-show="this.cantidadOne != 0"
               class="card-header card-header2"
              style="
                  background-color: rgb(90, 45, 130);
                  padding: 0.2rem 0.75rem !important;">
                <div class="card-title" style="font-size: 14px;display: flex;justify-content: space-between;width: 90%;">
                 <span>Puntos por ventas</span>
                 <span style="margin-left: 22px;">  {{cantidadOne}} </span>
                </div>
                
                <div class="card-tools" style="display: flex">

                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                    style="margin: 0"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body" style="padding: 0.5rem;">
                <div class="card" style="margin-bottom: 0.2rem;">
                  <ul class="list-group list-group-flush" style="overflow: auto;min-height: 0vh;max-height: 60vh;">
                   <ConsultaItem 
                    v-for="(subitem,index) in factura"
                    :subitem="subitem"
                    
                    ></ConsultaItem>
                  </ul>
                </div>
              </div>
            </div>
                 <div
              class="card card-success collapsed-card"
              style="margin-bottom: 10px;"
            >
              <div>
                <div>
                  <div></div>
                </div>
              </div>
              <div 
              v-show="this.cantidadTwo != 0"
               class="card-header card-header2"
              style="
                  background-color: rgb(0, 123, 255) !important;  
                  padding: 0.2rem 0.75rem !important;">
                <div class="card-title" style="font-size: 14px;display: flex;justify-content: space-between;width: 90%;">
                 <span>Puntos por devoluciones</span>
                 <span style="margin-left: 22px;">  {{cantidadTwo}} </span>
                </div>
                
                <div class="card-tools" style="display: flex">

                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                    style="margin: 0"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body" style="padding: 0.5rem;">
                <div class="card" style="margin-bottom: 0.2rem;">
                  <ul class="list-group list-group-flush" style="overflow: auto;min-height: 0vh;max-height: 60vh;">
                   <ConsultaItem 
                    v-for="(subitem,index) in NotaCredito"
                    :subitem="subitem"
                    
                    ></ConsultaItem>
                  </ul>
                </div>
              </div>
            </div>
            <!---->
          </div>
          </div>
          </div>
            <div v-show="!this.seleccion">
             <div class="col-12" style="margin-top: 27px;">
              <div class="TotalPoint"><i class="fas fa-star" style="color: #ebf803e0;margin-right: 7px;"></i> 
              <span style="font-weight: 400;padding-right: 6px;color: #337ab7;">Total de Puntos:  </span>
               <span style="font-weight: bold;color: rgb(90, 45, 130);font-size: 17px;">{{totalPuntosOne}} </span>  </div>
               <div class="TotalPoint" style="color: rgb(201 201 201);font-size: 14px;padding-bottom: 15px;"> Fecha de Actualización: {{fechaOne.substring(0,10)}}</div>
            </div>
          <div class="row" style="margin-bottom: 74px;margin-right: 0.5px;margin-left: 0.5px;">
             
             <div
            class="col-md-12"
           
            style="margin-bottom: 0px; padding-right: 0; padding-left: 0"
          >
            <div
              class="card card-success collapsed-card"
              style="margin-bottom: 10px;"
            >
              <div>
                <div>
                  <div></div>
                </div>
              </div>
              <div 
                v-show="this.cantidadThree != 0"
               class="card-header card-header2"
              style="
                  background-color: rgb(90, 45, 130);
                  padding: 0.2rem 0.75rem !important;">
                <div class="card-title" style="font-size: 14px;display: flex;justify-content: space-between;width: 90%;">
                 <span>Puntos por ventas</span>
                 <span style="margin-left: 22px;"> {{cantidadThree}} </span>
                </div>
                
                <div class="card-tools" style="display: flex">

                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                    style="margin: 0"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body" style="padding: 0.5rem;">
                <div class="card" style="margin-bottom: 0.2rem;">
                  <ul class="list-group list-group-flush" style="overflow: auto;min-height: 0vh;max-height: 60vh;">
                   <ConsultaItem 
                    v-for="(subitem,index) in facturaTwo"
                    :subitem="subitem"
                    
                    ></ConsultaItem>
                  </ul>
                </div>
              </div>
            </div>
                 <div
              class="card card-success collapsed-card"
              style="margin-bottom: 10px;"
            >
              <div>
                <div>
                  <div></div>
                </div>
              </div>
              <div 
                v-show="this.cantidadFor != 0"
               class="card-header card-header2"
              style="
                  background-color: rgb(0, 123, 255) !important;  
                  padding: 0.2rem 0.75rem !important;">
                <div class="card-title" style="font-size: 14px;display: flex;justify-content: space-between;width: 90%;">
                 <span>Puntos por devoluciones</span>
                 <span style="margin-left: 22px;">  {{cantidadFor}} </span>
                </div>
                
                <div class="card-tools" style="display: flex">

                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                    style="margin: 0"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body" style="padding: 0.5rem;">
                <div class="card" style="margin-bottom: 0.2rem;">
                  <ul class="list-group list-group-flush" style="overflow: auto;min-height: 0vh;max-height: 60vh;">
                   <ConsultaItem 
                    v-for="(subitem,index) in NotaCreditoTwo"
                    :subitem="subitem"
                    
                    ></ConsultaItem>
                  </ul>
                </div>
              </div>
            </div>
            <!---->
          </div>
          </div>
          </div>
           
        </div>

          <div class="row">
           
          </div>
          
        </div>
        <!--v-if-->
      </div>
    </div>
  </div>
</template>
<script>
import { saveAs } from "file-saver";
import XLSX from "xlsx";
import XLSTYLE from "xlsx-style";
import ConsultaItem from '@/components/ConsultaItem.vue';
export default {
  props: ["content"],
  components: {
    ConsultaItem
  },
  data: function () {
    return {

      factura:[],
      nuevoObjeto:[],
      NotaCredito:[],
      facturaTwo:[],
      NotaCreditoTwo:[],
      consulPuntosOne:[],
      consulPuntosTwo:[],
      totalPuntosOne:'',
      totalPuntosTwo:'',
      fechaOne:'',
      fechaTwo:'',
      vcampanaOne:'',
      vcampanaTwo:'',
      cantidadOne:0,
      cantidadTwo:0,
      cantidadThree:0,
      cantidadFor:0,
      seleccion:true,
      One:'1',
      load:false,
      change:'',
      vlorOne:'',
      vlrTwo:'',
      campañaOne:'',
      campañaTwo:''



      

    };
  },

  mounted() {


    this.content.title = "CONSULTA DE PUNTOS";
    this.producto = true;
    this.content.showBody = true;


    this.load = true
   let backend = this.$store.state.backend;




this.axios
   .get(backend+'/API/Puntos/DescargaPuntos',{
         headers:{
            Authorization: "Bearer " + localStorage.token,      
        },
   })
   .then((response)=>{
        this.load = false
        this.vlorOne = response.data.olPuntosDescarga[0].olDet
        this.vlrTwo = response.data.olPuntosDescarga[1].olDet

          this.campañaOne = response.data.olPuntosDescarga[0].vCampana
          this.campañaTwo = response.data.olPuntosDescarga[1].vCampana


   })

     .catch((error) => {
          error.handleGlobally && error.handleGlobally();
        });









   this.axios
   .get(backend+'/api/Puntos/ConsultaPuntos', {
        headers:{
                    Authorization: "Bearer " + localStorage.token,      
                  },
   })
   .then((response)=>{
      this.load = false
        if(response.data.olPuntos.length > 1){
         let data = response.data.olPuntos
         this.change = data.length
      
        let valorOne = response.data.olPuntos[0]
        let valorOTwo = response.data.olPuntos[1]

    //iguala variables para pintar campos independientes 
        this.vcampanaOne = valorOne.vcampana
        this.totalPuntosOne = valorOne.puntaje
        let fechaO = valorOne.dfechacarga.substring(0,10)
        let valorfecha =  fechaO.split('-')
        this.fechaOne = valorfecha[2]+'-'+valorfecha[1] +'-'+valorfecha[0]
        this.totalPuntosTwo = valorOTwo.puntaje
        let fechaT = valorOTwo.dfechacarga.substring(0,10)
        let valorfechaT =  fechaT.split('-')
        this.fechaTwo = valorfechaT[2]+'-'+valorfechaT[1] +'-'+valorfechaT[0]
      

        this.vcampanaTwo = valorOTwo.vcampana

        this.consulPuntosOne = response.data.olPuntos[0].olDet
        this.consulPuntosTwo = response.data.olPuntos[1].olDet

    //filtra por factura y nota de credito
        let valorNOne =  this.consulPuntosTwo.filter(del=>{return del.difDoc == '1'})
        this.factura = valorNOne

        let valorNTwo =  this.consulPuntosTwo.filter(del=>{return del.difDoc == '0'})
        this.NotaCredito = valorNTwo

        let valorCampTwoFact =  this.consulPuntosOne.filter(del=>{return del.difDoc == '1'})
        this.facturaTwo = valorCampTwoFact

        let valorCampTwoNCto =  this.consulPuntosOne.filter(del=>{return del.difDoc == '0'})
        this.NotaCreditoTwo = valorCampTwoNCto

    //filtra  factura y nota de credito por sección

        this.cantidadOne +=  this.factura.reduce((a, b) => a + b.puntaje,0);
        this.cantidadTwo +=  this.NotaCredito.reduce((a, b) => a + b.puntaje,0);
        this.cantidadThree +=  this.facturaTwo.reduce((a, b) => a + b.puntaje,0);
        this.cantidadFor +=  this.NotaCreditoTwo.reduce((a, b) => a + b.puntaje,0);

 }
 else{

         let data = response.data.olPuntos
         this.change = data.length

        this.seleccion = false
        this.One = 0
        let valorOne = response.data.olPuntos[0]

    //iguala variables para pintar campos independientes 
        this.vcampanaOne = valorOne.vcampana
        this.totalPuntosOne = valorOne.puntaje
      


        this.consulPuntosOne = response.data.olPuntos[0].olDet

    //filtra por factura y nota de credito
        let valorCampTwoFact =  this.consulPuntosOne.filter(del=>{return del.difDoc == '1'})
        this.facturaTwo = valorCampTwoFact

        let valorCampTwoNCto =  this.consulPuntosOne.filter(del=>{return del.difDoc == '0'})
        this.NotaCreditoTwo = valorCampTwoNCto


    //filtra  factura y nota de credito por sección

 
        this.cantidadThree +=  this.facturaTwo.reduce((a, b) => a + b.puntaje,0);
        this.cantidadFor +=  this.NotaCreditoTwo.reduce((a, b) => a + b.puntaje,0);


        let fechaO = valorOne.dfechacarga.substring(0,10)
        let valorfecha =  fechaO.split('-')
        this.fechaOne = valorfecha[2]+'-'+valorfecha[1] +'-'+valorfecha[0]

 }
  
   })
    .catch((error) => {
          error.handleGlobally && error.handleGlobally();
        });
  },
  
  methods: {
    
   

  Descargar() {
  
    const wb = { SheetNames: [], Sheets: {} };
    const ws_name = "Reporte";
     var tmpPedidos = [];
          var tmpMerge = [];
          var positionCell = 0;
          var cellsStyle = [];
          const tmpPedido = [];

          tmpPedido.push("Campaña");
          tmpPedido.push("Fecha Facturación");
          tmpPedido.push("Tipo Documento");
          tmpPedido.push("Nro Documento");
          tmpPedido.push("Descripción");
          tmpPedido.push("Talla-Color");
          tmpPedido.push("Puntos");


        
          tmpPedidos.push(tmpPedido);
          if(this.seleccion == true){
           if (this.vlrTwo.length > 0) {
             let campañaTwo = this.campañaTwo
              this.vlrTwo.forEach((ped) => {
              let fechaO = ped.dFechaCreacion.substring(0,10)
              let valorfecha =  fechaO.split('-')
              let verFechaOne = valorfecha[2]+'-'+valorfecha[1] +'-'+valorfecha[0]

                const tmpdetPedido = [];

                tmpdetPedido.push(campañaTwo);
                tmpdetPedido.push(verFechaOne);
                tmpdetPedido.push(ped.clase);
                tmpdetPedido.push(ped.vNroFactura);
                tmpdetPedido.push(ped.vDescripcionMaterial);
                tmpdetPedido.push(ped.vValorMatriz);
                tmpdetPedido.push(ped.iPuntaje);

                tmpPedidos.push(tmpdetPedido);
            
            });  
          }
        }
        else if(this.seleccion == false){
         if (this.vlorOne.length > 0) {
            let campañaOne = this.campañaOne
            this.vlorOne.forEach((ped) => {
             
              let fechaO = ped.dFechaCreacion.substring(0,10)
              let valorfecha =  fechaO.split('-')
              let verFechaOne = valorfecha[2]+'-'+valorfecha[1] +'-'+valorfecha[0]

                const tmpdetPedido = [];

                tmpdetPedido.push(campañaOne);
                tmpdetPedido.push(verFechaOne);
                tmpdetPedido.push(ped.clase);
                tmpdetPedido.push(ped.vNroFactura);
                tmpdetPedido.push(ped.vDescripcionMaterial);
                tmpdetPedido.push(ped.vValorMatriz);
                tmpdetPedido.push(ped.iPuntaje);

                tmpPedidos.push(tmpdetPedido);
            
            });  
          }
        }
     
        

          var sheet = XLSX.utils.aoa_to_sheet(tmpPedidos);
          sheet["!merges"] = tmpMerge;
          sheet["A1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
      sheet["B1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
      sheet["C1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
      sheet["D1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
        sheet["E1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
        sheet["F1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
        sheet["G1"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };
   

 
      sheet["!cols"] = [
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
         {
          wpx: 150,
        },
         {
          wpx: 150,
        },
         {
          wpx: 150,
        },
       
       
      ];
          var style_default = {
            font: { sz: 13, bold: true },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrap_text: true,
            },
          }

          wb.SheetNames.push(ws_name);
          wb.Sheets[ws_name] = sheet;
          const wbout = XLSTYLE.write(wb, {
            type: "binary",
            bookSST: true,
            bookType: "xlsx",
            cellStyles: true,
          });
          saveAs(
            new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
            "TotalPuntos.xlsx"
          )
  
    },
      s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

 
    campanaOne(){
        this.seleccion = true
    },
      campanaTwo(){
        this.seleccion = false
    }



  },
};
</script>
<style scoped>
.changeNew{
      background-color: rgb(132 96 165) !important;
}
.gridTemplate{
  grid-column: span 3;
  background: rgb(164 204 247);
  color: white;
  padding-left: 9px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 0px 0px 5px 5px;
}
.changeColor{
      background: rgb(90, 45, 130) !important;

}
.seeCondition{
    background: rgb(90, 45, 130);
    border: rgb(90, 45, 130);
    width: 37%;
    color: white;
    border-radius: 3px;
    height: 35px;
    outline: none;
    font-size: 13px;
}

.seeCampaña{
    border: rgb(90, 45, 130);
    width: 26%;
    color: white;
    border-radius: 3px;
    height: 34px;
    outline: none;
    font-size:13px;
}
.TotalPoint{
    display: flex;
    align-items: baseline;
    justify-content: center;
    padding-bottom: 5px;
}

</style>
